"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var webIDLConversions = require("webidl-conversions");
var DOMException = require("domexception/webidl2js-wrapper");
var NODE_TYPE = require("../node-type");
var _require = require("../helpers/namespaces"),
  HTML_NS = _require.HTML_NS;
var _require2 = require("../helpers/create-element"),
  getHTMLElementInterface = _require2.getHTMLElementInterface;
var _require3 = require("../helpers/shadow-dom"),
  shadowIncludingInclusiveDescendantsIterator = _require3.shadowIncludingInclusiveDescendantsIterator;
var _require4 = require("../helpers/custom-elements"),
  isValidCustomElementName = _require4.isValidCustomElementName,
  tryUpgradeElement = _require4.tryUpgradeElement,
  enqueueCEUpgradeReaction = _require4.enqueueCEUpgradeReaction;
var idlUtils = require("../generated/utils");
var IDLFunction = require("../generated/Function.js");
var HTMLUnknownElement = require("../generated/HTMLUnknownElement");
var LIFECYCLE_CALLBACKS = ["connectedCallback", "disconnectedCallback", "adoptedCallback", "attributeChangedCallback"];
function convertToSequenceDOMString(obj) {
  if (!obj || !obj[Symbol.iterator]) {
    throw new TypeError("Invalid Sequence");
  }
  return Array.from(obj).map(webIDLConversions.DOMString);
}

// Returns true is the passed value is a valid constructor.
// Borrowed from: https://stackoverflow.com/a/39336206/3832710
function isConstructor(value) {
  if (typeof value !== "function") {
    return false;
  }
  try {
    var P = new Proxy(value, {
      construct: function construct() {
        return {};
      }
    });

    // eslint-disable-next-line no-new
    new P();
    return true;
  } catch (_unused) {
    return false;
  }
}

// https://html.spec.whatwg.org/#customelementregistry
var CustomElementRegistryImpl = /*#__PURE__*/function () {
  function CustomElementRegistryImpl(globalObject) {
    _classCallCheck(this, CustomElementRegistryImpl);
    this._customElementDefinitions = [];
    this._elementDefinitionIsRunning = false;
    this._whenDefinedPromiseMap = Object.create(null);
    this._globalObject = globalObject;
  }

  // https://html.spec.whatwg.org/#dom-customelementregistry-define
  _createClass(CustomElementRegistryImpl, [{
    key: "define",
    value: function define(name, constructor, options) {
      var _globalObject = this._globalObject;
      var ctor = constructor.objectReference;
      if (!isConstructor(ctor)) {
        throw new TypeError("Constructor argument is not a constructor.");
      }
      if (!isValidCustomElementName(name)) {
        throw DOMException.create(_globalObject, ["Name argument is not a valid custom element name.", "SyntaxError"]);
      }
      var nameAlreadyRegistered = this._customElementDefinitions.some(function (entry) {
        return entry.name === name;
      });
      if (nameAlreadyRegistered) {
        throw DOMException.create(_globalObject, ["This name has already been registered in the registry.", "NotSupportedError"]);
      }
      var ctorAlreadyRegistered = this._customElementDefinitions.some(function (entry) {
        return entry.objectReference === ctor;
      });
      if (ctorAlreadyRegistered) {
        throw DOMException.create(_globalObject, ["This constructor has already been registered in the registry.", "NotSupportedError"]);
      }
      var localName = name;
      var extendsOption = null;
      if (options !== undefined && options["extends"]) {
        extendsOption = options["extends"];
      }
      if (extendsOption !== null) {
        if (isValidCustomElementName(extendsOption)) {
          throw DOMException.create(_globalObject, ["Option extends value can't be a valid custom element name.", "NotSupportedError"]);
        }
        var extendsInterface = getHTMLElementInterface(extendsOption);
        if (extendsInterface === HTMLUnknownElement) {
          throw DOMException.create(_globalObject, ["".concat(extendsOption, " is an HTMLUnknownElement."), "NotSupportedError"]);
        }
        localName = extendsOption;
      }
      if (this._elementDefinitionIsRunning) {
        throw DOMException.create(_globalObject, ["Invalid nested custom element definition.", "NotSupportedError"]);
      }
      this._elementDefinitionIsRunning = true;
      var disableShadow = false;
      var observedAttributes = [];
      var lifecycleCallbacks = {
        connectedCallback: null,
        disconnectedCallback: null,
        adoptedCallback: null,
        attributeChangedCallback: null
      };
      var caughtError;
      try {
        var prototype = ctor.prototype;
        if (_typeof(prototype) !== "object") {
          throw new TypeError("Invalid constructor prototype.");
        }
        for (var _i = 0, _LIFECYCLE_CALLBACKS = LIFECYCLE_CALLBACKS; _i < _LIFECYCLE_CALLBACKS.length; _i++) {
          var callbackName = _LIFECYCLE_CALLBACKS[_i];
          var callbackValue = prototype[callbackName];
          if (callbackValue !== undefined) {
            lifecycleCallbacks[callbackName] = IDLFunction.convert(_globalObject, callbackValue, {
              context: "The lifecycle callback \"".concat(callbackName, "\"")
            });
          }
        }
        if (lifecycleCallbacks.attributeChangedCallback !== null) {
          var observedAttributesIterable = ctor.observedAttributes;
          if (observedAttributesIterable !== undefined) {
            observedAttributes = convertToSequenceDOMString(observedAttributesIterable);
          }
        }
        var disabledFeatures = [];
        var disabledFeaturesIterable = ctor.disabledFeatures;
        if (disabledFeaturesIterable) {
          disabledFeatures = convertToSequenceDOMString(disabledFeaturesIterable);
        }
        disableShadow = disabledFeatures.includes("shadow");
      } catch (err) {
        caughtError = err;
      } finally {
        this._elementDefinitionIsRunning = false;
      }
      if (caughtError !== undefined) {
        throw caughtError;
      }
      var definition = {
        name: name,
        localName: localName,
        constructor: constructor,
        objectReference: ctor,
        observedAttributes: observedAttributes,
        lifecycleCallbacks: lifecycleCallbacks,
        disableShadow: disableShadow,
        constructionStack: []
      };
      this._customElementDefinitions.push(definition);
      var document = idlUtils.implForWrapper(this._globalObject._document);
      var upgradeCandidates = [];
      var _iterator = _createForOfIteratorHelper(shadowIncludingInclusiveDescendantsIterator(document)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var candidate = _step.value;
          if (candidate._namespaceURI === HTML_NS && candidate._localName === localName && (extendsOption === null || candidate._isValue === name)) {
            upgradeCandidates.push(candidate);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      for (var _i2 = 0, _upgradeCandidates = upgradeCandidates; _i2 < _upgradeCandidates.length; _i2++) {
        var upgradeCandidate = _upgradeCandidates[_i2];
        enqueueCEUpgradeReaction(upgradeCandidate, definition);
      }
      if (this._whenDefinedPromiseMap[name] !== undefined) {
        this._whenDefinedPromiseMap[name].resolve(ctor);
        delete this._whenDefinedPromiseMap[name];
      }
    }

    // https://html.spec.whatwg.org/#dom-customelementregistry-get
  }, {
    key: "get",
    value: function get(name) {
      var definition = this._customElementDefinitions.find(function (entry) {
        return entry.name === name;
      });
      return definition && definition.objectReference;
    }

    // https://html.spec.whatwg.org/#dom-customelementregistry-whendefined
  }, {
    key: "whenDefined",
    value: function whenDefined(name) {
      if (!isValidCustomElementName(name)) {
        return Promise.reject(DOMException.create(this._globalObject, ["Name argument is not a valid custom element name.", "SyntaxError"]));
      }
      var alreadyRegistered = this._customElementDefinitions.find(function (entry) {
        return entry.name === name;
      });
      if (alreadyRegistered) {
        return Promise.resolve(alreadyRegistered.objectReference);
      }
      if (this._whenDefinedPromiseMap[name] === undefined) {
        var resolve;
        var promise = new Promise(function (r) {
          resolve = r;
        });

        // Store the pending Promise along with the extracted resolve callback to actually resolve the returned Promise,
        // once the custom element is registered.
        this._whenDefinedPromiseMap[name] = {
          promise: promise,
          resolve: resolve
        };
      }
      return this._whenDefinedPromiseMap[name].promise;
    }

    // https://html.spec.whatwg.org/#dom-customelementregistry-upgrade
  }, {
    key: "upgrade",
    value: function upgrade(root) {
      var _iterator2 = _createForOfIteratorHelper(shadowIncludingInclusiveDescendantsIterator(root)),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var candidate = _step2.value;
          if (candidate.nodeType === NODE_TYPE.ELEMENT_NODE) {
            tryUpgradeElement(candidate);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);
  return CustomElementRegistryImpl;
}();
module.exports = {
  implementation: CustomElementRegistryImpl
};